"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MelhorEnvio = void 0;
const axios_1 = __importDefault(require("axios"));
const errors_1 = require("../errors");
const checkTokenValid_1 = __importDefault(require("../utils/checkTokenValid"));
const MENV_SANDBOX_API_URL = 'https://sandbox.melhorenvio.com.br';
const MENV_API_URL = 'https://www.melhorenvio.com.br';
class MelhorEnvio {
    /**
     * 🚚 Melhor Envio Javascript API
     * @param token Token for API Requests. Can be generated direct in Melhor Envio Dashboard.
     * @param isSandbox Use or not a sandbox environment for testing.
     * @param timeout Timeout of the request.
     * @param appInfo Info about your application
     */
    constructor(token, isSandbox = false, timeout = 5000, appInfo) {
        this.token = token;
        this.isSandbox = isSandbox;
        this.timeout = timeout;
        this.appInfo = appInfo;
        if (!checkTokenValid_1.default(token)) {
            throw new Error('Your token has expired');
        }
    }
    sanitizePostalCode(postalCode) {
        return postalCode.toString().replace(/\D+/g, '');
    }
    /**
     * 📨 Fetch in the MelhorEnvio API
     *
     * @param url URL. Route to the fetch. can be `/test`
     * @param method Method. Can be *GET*. *POST*.
     * @param params Querystring params. Its most used in *GET* requests.
     * @param data Data. Use for *POST* requests.
     */
    async fetch(url, method = 'GET', params = {}, data = {}) {
        return axios_1.default
            .request({
            baseURL: this.isSandbox ? MENV_SANDBOX_API_URL : MENV_API_URL,
            method,
            url,
            timeout: this.timeout,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
                Authorization: `Bearer ${this.token}`,
                'User-Agent': this.appInfo
                    ? `${this.appInfo.name} (${this.appInfo.email})`
                    : undefined
            },
            params,
            data
        })
            .then((response) => response.data)
            .catch((error) => {
            if (error.response) {
                console.log(error.response.data);
                throw new errors_1.MelhorEnvioFetchServerError(error.message, error.config, error.code, error.request, error.response);
            }
            else if (error.request) {
                throw new errors_1.MelhorEnvioFetchClientError(error.message, error.config, error.code, error.request);
            }
            else {
                throw new errors_1.MelhorEnvioFetchOtherError(error.message, error.config);
            }
        });
    }
    /**
     * 💵 Calculate quote for shipment
     */
    async calculateShipment({ fromPostalCode, toPostalCode, productsOrPackageData, services, receipt = false, ownHand = false, insuranceValue = 0 }) {
        const data = {
            from: {
                postal_code: this.sanitizePostalCode(fromPostalCode)
            },
            to: {
                postal_code: this.sanitizePostalCode(toPostalCode)
            },
            options: {
                receipt,
                own_hand: ownHand,
                insurance_value: insuranceValue
            }
        };
        if (services) {
            data.services =
                Array.isArray(services) && services.length > 0
                    ? services.join(',')
                    : services;
        }
        if (Array.isArray(productsOrPackageData)) {
            data.products = productsOrPackageData;
        }
        else {
            data.package = productsOrPackageData;
        }
        return this.fetch('/api/v2/me/shipment/calculate', 'POST', {}, data);
    }
    async getShipmentServices() {
        return this.fetch('/api/v2/me/shipment/services', 'GET');
    }
    async addItemInCart(data) {
        return this.fetch('/api/v2/me/cart', 'POST', {}, data);
    }
    async checkout(data) {
        return this.fetch('/api/v2/me/shipment/checkout', 'POST', {}, data);
    }
    async generateLabel(data) {
        return this.fetch('/api/v2/me/shipment/generate', 'POST', {}, data);
    }
    async printLabel(data) {
        return this.fetch('/api/v2/me/shipment/print', 'POST', {}, data);
    }
    async track(data) {
        return this.fetch('/api/v2/me/shipment/tracking', 'POST', {}, data);
    }
}
exports.MelhorEnvio = MelhorEnvio;
//# sourceMappingURL=index.js.map